import { TYPE_REDUCER } from "../utils/constants";
import { getConfigUI } from "../utils/getConfigUI";
import { itemMenu, listGlobalMenu } from "../../utils/listGlobalMenu";
import { views, viewT } from "../../utils/listView";
import { settingConfigT, settingUI } from "../../utils/settingConfig";
import { IComponent } from "../../utils/type/dynamic-rendering.interfaces";
import { responseMessageT } from "../middleware";

import { settingForSides } from "../../utils/listSettingSides";
import { getValueOption, valueOption } from "../selectors/selectors";
import shortid from 'shortid';
import { saveActiveSectionT } from "../../utils/type/typesTempSectionSides";
import { initializationThreeKitDataT } from "../..";
 
export type listActiveSettingT = {
  sectionId: string,
  listOptions: activeOption[]
}

export type activeOption = {
  sectionId: string,
  optionId: string,
  settingUI: string,
  value: any
  isError: boolean
}

export type stateT = {
  view: {
    listViews: viewT[];
    activeView: string;
  },
  sections: {
    listSection: itemMenu[];
    activeSection: string;
  },
  paramsConfiguration: {
    allSetting: any;
    settingUI: settingConfigT[];
    activeSettingUI: listActiveSettingT[];
    settingForSides: IComponent[]

  },
  interface: {
    isLoadStateData: boolean;
    isLoad: boolean;
    openSectionIdInSides: string;
  },
  modalInfo: {
    visiblePrice: boolean;
    visibleSaveConfig: boolean;
    notificationModal: responseMessageT[] | null;
  },
  initializationThreekitData: initializationThreeKitDataT
}


const initialState: stateT = {
  view: {
    listViews: views,
    activeView: 'SideA',
  },
  sections: {
    listSection: listGlobalMenu,
    activeSection: 'Product',
  },
  paramsConfiguration: {
    allSetting: null,
    settingUI: settingUI,
    activeSettingUI: [],
    settingForSides: settingForSides,

  },
  interface: {
    isLoadStateData: false,
    isLoad: false,
    openSectionIdInSides: '',
  },
  modalInfo: {
    visiblePrice: false,
    visibleSaveConfig: false,
    notificationModal: null,
  },
  initializationThreekitData: {
    threekitUrl: "https://preview.threekit.com/",
    authToken: "",
    assetId: ""
  },

};

const Settings = (state = initialState, action: any) => {
  switch (action.type) {
    case TYPE_REDUCER.SET_INITIALIZATION_THREEKIT:
      {

        const { initializationThreekit } = action.payload;

        return {
          ...state,
          initializationThreekitData: initializationThreekit
        };
      }

    case TYPE_REDUCER.SET_ALL_SETTING_CONFIG:
      {
        const { allSetting, configurationParams } = action.payload;



        let settingUICopy: settingConfigT[] = JSON.parse(JSON.stringify(getConfigUI(allSetting, settingUI)));


        let createArrayActiveSetting = (settingUIState: settingConfigT[]): listActiveSettingT[] => {
          let arrayUISettingTemp: listActiveSettingT[] = [];



          const setItemActiveSetting = (listOptions: activeOption[]) => (SectionID: any) => (settingUI: IComponent) => {
            if (!!settingUI['data']['embeddedView'] && settingUI['data']['embeddedView'].length > 0) {
              let activeOption = checkCreateActiveOption({ SectionID, settingUI });
              !!activeOption && listOptions.push(activeOption)


              settingUI['data']['embeddedView'].forEach((settingUI: IComponent) => {
                setItemActiveSetting(listOptions)(SectionID)(settingUI)
              })
            } else {
              let activeOption = checkCreateActiveOption({ SectionID, settingUI });
              !!activeOption && listOptions.push(activeOption)
            }

            function checkCreateActiveOption({ settingUI }: { SectionID: any, settingUI: IComponent }): any {
              if (!!settingUI['data']['isVisible']) {
                // return (settingUI);

              } else if (!!settingUI['data']['switchingOptions']) {
                return createActiveOption(settingUI)
              } else if (settingUI['data']['typeOptions'] === 'configurationOptions') {
                return createActiveOption(settingUI)
              } else if (settingUI['data']['typeOptions'] === 'groupingOptionsSwitchingOpening') {
                return createActiveOption(settingUI)
              }
            }

            function createActiveOption(settingUI: IComponent): activeOption {
              return { sectionId: SectionID, optionId: settingUI['data']['id'], settingUI: settingUI['data']['typeOptions'], value: settingUI['data']['switchingOptions'], isError: false }
            }

          }

          settingUIState.forEach((section: settingConfigT) => {
            let listOptions: activeOption[] = []
            section['setting'].forEach((settingUI: IComponent) => setItemActiveSetting(listOptions)(section['key'])(settingUI))

            arrayUISettingTemp.push({
              sectionId: section['key'],
              listOptions: listOptions
            })

          })

          return arrayUISettingTemp;
        }

        let listActiveSettings: listActiveSettingT[] = createArrayActiveSetting(settingUICopy);
        console.log(listActiveSettings);
        console.log(configurationParams);
        listActiveSettings.forEach((listActiveSetting: listActiveSettingT) => {
          if (!!configurationParams) {
            listActiveSetting['listOptions'].map((item: activeOption) => {
              if (configurationParams[item['optionId']]) {
                item['value'] = configurationParams[item['optionId']]
              }
            })
          }
        })

        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,
            allSetting: allSetting,
            settingUI: settingUICopy,
            activeSettingUI: listActiveSettings,
          },
          interface: {
            isLoadStateData: true,
          },
        };
      }

    case TYPE_REDUCER.SET_ACTIVE_THREEKIT_PARAMS:
      {

        const { configurationParams } = action.payload;
        let listActiveSetting: activeOption[] = JSON.parse(JSON.stringify(state.paramsConfiguration.activeSettingUI));

        if (!!configurationParams) {
          listActiveSetting.map((item: activeOption) => {
            if (configurationParams[item['optionId']]) {
              item['value'] = !item['value'] && configurationParams[item['optionId']]
            }

          })
        }
        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,

            activeSettingUI: listActiveSetting,
          },
        };
      }
    case TYPE_REDUCER.SET_VALUE_OPTIONS:
      {

        const { idParams, valueParam, parentKeySection } = action.payload;

        let activeSettingUI: listActiveSettingT[] = state['paramsConfiguration']['activeSettingUI'];
        let activeSection: string = state['sections']['activeSection'];


        let activeSectionOptions: listActiveSettingT = activeSettingUI.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]

        if (activeSection === 'Sides' && !!parentKeySection) {
          let activeSide: activeOption = activeSectionOptions['listOptions'].filter((item: activeOption) => item['optionId'] === 'orientationSide')[0]
          // debugger
          let activeSectionOption1s = activeSectionOptions['listOptions'].filter((item: activeOption) => item['optionId'].includes(activeSide['value']))[0]
          // debugger



          if (!!activeSectionOption1s['value']) {
            if (!!activeSectionOption1s['value'][parentKeySection]) {
              activeSectionOption1s['value'][parentKeySection] = {
                ...activeSectionOption1s['value'][parentKeySection],
                [idParams]: {
                  value: valueParam,
                  isError: false
                }
              }
            } else {
              activeSectionOption1s['value'] = {
                ...activeSectionOption1s['value'],
                [parentKeySection]: {
                  [idParams]: {
                    value: valueParam,
                    isError: false
                  }
                }
              }
            }
          } else {
            activeSectionOption1s['value'] = {
              [parentKeySection]: {
                [idParams]: {
                  value: valueParam,
                  isError: false
                }
              }
            }
          }



          return {
            ...state,
            paramsConfiguration: {
              ...state.paramsConfiguration,
              activeSettingUI: activeSettingUI
            }
          }



        }





        let option = activeSectionOptions['listOptions'].filter((option) => option['optionId'] === idParams)[0]
        // debugger

        option['value'] = valueParam;
        option['isError'] = false;

        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,
            activeSettingUI: activeSettingUI
          }
        };
      }
    case TYPE_REDUCER.SET_SIDE_OPTION_ARRAY:
      {
        const { idParams, valueParam } = action.payload;
        let stateCopy: any = {
          'Configuration': JSON.parse(JSON.stringify(state))
        }

        let activeSettingUI: listActiveSettingT[] = state['paramsConfiguration']['activeSettingUI'];
        let activeSection: string = state['sections']['activeSection'];


        let { selectValue }: valueOption = getValueOption({ idOptions: 'orientationSide' })(stateCopy)

        let activeSectionOptions: listActiveSettingT = activeSettingUI.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]


        let option = activeSectionOptions['listOptions'].filter((option) => option['optionId'] === idParams)[0]



        if (!!selectValue) {


          if (!!option['value'] && !!option['value'][selectValue]) {
            let sectionIndividual: saveActiveSectionT = {
              keySection: shortid.generate(),
              idSection: valueParam
            }
            option['value'][selectValue].push(sectionIndividual)
          } else {
            let sectionIndividual: saveActiveSectionT = {
              keySection: shortid.generate(),
              idSection: valueParam
            }
            option['value'] = {
              ...option['value'],
              [selectValue]: [sectionIndividual]
            }

          }

          return {
            ...state,
            paramsConfiguration: {
              ...state.paramsConfiguration,
              activeSettingUI: activeSettingUI
            }
          };
        }


        // option['value'] = valueParam;
        // option['isError'] = false;

        return {
          ...state,
          // paramsConfiguration: {
          //   ...state.paramsConfiguration,
          //   activeSettingUI: activeSettingUI
          // }
        };
      }
    case TYPE_REDUCER.SET_VALUE_MULTIPLE_OPTIONS:
      {

        const { idParams, valueParam } = action.payload;

        let activeSettingUI: listActiveSettingT[] = state['paramsConfiguration']['activeSettingUI'];
        let activeSection: string = state['sections']['activeSection'];

        let activeSectionOptions: listActiveSettingT = activeSettingUI.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]
        let option = activeSectionOptions['listOptions'].filter((option) => option['optionId'] === idParams)[0]

        if (!!option['value']) {

          if (option['value'].includes(valueParam)) {
            option['value'] = option['value'].filter((item: any) => item !== valueParam)
          } else {
            option['value'].push(valueParam)
          }

        } else {
          option['value'] = [valueParam];
        }


        option['isError'] = false;

        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,
            activeSettingUI: activeSettingUI
          }
        };
      }

    case TYPE_REDUCER.CHANGE_STEP:
      {
        const newKeyStep = action.payload;
        return {
          ...state,
          sections: {
            ...state.sections,
            activeSection: newKeyStep
          }
        };
      }
    case TYPE_REDUCER.CHANGE_VIEW:
      {
        const newKeyView = action.payload;
        return {
          ...state,
          view: {
            ...state.view,
            activeView: newKeyView
          }
        };
      }
    case TYPE_REDUCER.MODAL_SWITCHING:
      {
        const { idModal, conditionModal } = action.payload;

        return {
          ...state,
          modalInfo: {
            ...state.modalInfo,
            [idModal]: conditionModal,
          },
        };
      }
    case TYPE_REDUCER.UPDATE_SETTINGS:
      {
        const Settings = action.payload;

        let settingUICopy = JSON.parse(JSON.stringify(getConfigUI(Settings, settingUI)));


        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,
            settingUI: settingUICopy,
          },
          interface: {
            isLoadStateData: true,
          },
        };
      }
    case TYPE_REDUCER.SHOW_NOTIFICATION:
      {
        const messages: responseMessageT[] | [] = action.payload;

        let activeSettingUINew: listActiveSettingT[] = state.paramsConfiguration['activeSettingUI']
        let activeSection: string = state['sections']['activeSection'];

        let activeSectionOptions: listActiveSettingT = activeSettingUINew.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]
        //@ts-ignore
        messages.map(message => {
          //@ts-ignore
          if (message['error']) {
            let setting: activeOption = activeSectionOptions['listOptions'].filter(item => item['optionId'] === message['field'])[0];
            setting['isError'] = true;
          }
        })

        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,
            activeSettingUI: activeSettingUINew
          },
          modalInfo: {
            ...state.modalInfo,
            notificationModal: messages,
          }
        };
      }
    case TYPE_REDUCER.CLOSE_NOTIFICATION:
      {
        const notification: responseMessageT = action.payload;

        let notificationsModal = JSON.parse(JSON.stringify(state['modalInfo']['notificationModal']));

        let notificationsModalNew = notificationsModal.filter((item: responseMessageT) => item['message'] !== notification['message'])

        if (!notificationsModalNew && notificationsModalNew <= 0) {
          notificationsModalNew = null
        }

        return {
          ...state,
          modalInfo: {
            ...state.modalInfo,
            notificationModal: notificationsModalNew,
          }
        };
      }
    case TYPE_REDUCER.SET_OPEN_SECTION_ID_IN_SIDES:
      {
        const { idSection } = action.payload;


        let openSectionIdInSides = idSection
        if (state.interface.openSectionIdInSides === idSection) {
          openSectionIdInSides = ''
        }

        return {
          ...state,
          interface: {
            ...state.interface,
            openSectionIdInSides: openSectionIdInSides
          }
        };
      }
    case TYPE_REDUCER.REMOVE_TEMP_SECTION:
      {
        const { keySection } = action.payload;

        let activeSettingUINew: listActiveSettingT[] = state.paramsConfiguration['activeSettingUI']
        let activeSection: string = state['sections']['activeSection'];

        let activeSectionOptions: listActiveSettingT = activeSettingUINew.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]

        let orientationSide: activeOption = activeSectionOptions['listOptions'].filter((option) => option['optionId'] === "orientationSide")[0]
        let orientationSideView: activeOption = activeSectionOptions['listOptions'].filter((option) => option['optionId'] === "orientationSideView")[0]
        let sideSectionActive: activeOption = activeSectionOptions['listOptions'].filter((option) => option['optionId'].includes(orientationSide['value']))[0]

        orientationSideView['value'][orientationSide['value']] = orientationSideView['value'][orientationSide['value']].filter((sectionTemp: any) => sectionTemp['keySection'] !== keySection)

        if (!!sideSectionActive['value'] && !!sideSectionActive['value']['keySection']) {
          delete sideSectionActive['value']['keySection']
        }


        return {
          ...state,
          paramsConfiguration: {
            ...state.paramsConfiguration,
            activeSettingUI: activeSettingUINew
          }
        };
      }



    default:
      return state;
  }
};

export default Settings;
